import React, { useState } from 'react';
import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import InputsSection from '../../components/Modal/InputsSection';
import InputsSectionColumn from '../../components/Modal/InputsSectionColumn';
import InputBox from '../../components/Modal/InputBox';
import ModalButtons from '../../components/Modal/ModalButtons';
import AddUserSkeleton from '../../components/Skeletons/AddUserSkeleton';

import TextBox from '../../components/Modal/InputBox/TextBox.module.css';

const AddOrgModal = ({ addOrgModal, handleAddModalClose, handleAddOrg, createOrgLoading, updateOrgLoading, data }) => {
  const {
    orgName,
    setOrgName,
    orgEmail,
    setOrgEmail,
    orgPhone,
    setOrgPhone,
    orgAddress,
    setOrgAddress,
    orgLogo,
    setOrgLogo,
    customClientData,
    setCustomClientData,
    editOrgData,
    orgModules,
    setOrgModules,
  } = data;

  const [showAdminChatOnly, setShowAdminChatOnly] = useState(false);

  return (
    <Modal show={addOrgModal}>
      <ModalHeading heading={editOrgData && editOrgData._id ? 'Update Client Data' : 'Add New Client'} />
      {createOrgLoading || updateOrgLoading ? (
        <AddUserSkeleton />
      ) : (
        <ModalForm style={{ marginBottom: '2.5rem' }}>
          <InputsSection>
            <InputBox
              label='Client Name'
              placeholder='eg, John&#39;s Company'
              value={orgName.value}
              onChange={event => {
                setOrgName({ value: event.target.value, error: '' });
              }}
              errorMessage={orgName.error}
            />
            <InputBox
              label='Client Email'
              placeholder='eg, johncompany@example.com'
              value={orgEmail.value}
              onChange={event => {
                setOrgEmail({ value: event.target.value, error: '' });
              }}
              errorMessage={orgEmail.error}
              style={{ width: '25rem' }}
            />
            <InputBox
              label='Client Phone'
              placeholder='eg, 123-456-789'
              value={orgPhone.value}
              onChange={event => {
                setOrgPhone({ value: event.target.value, error: '' });
              }}
              errorMessage={orgPhone.error}
            />
          </InputsSection>
          <InputsSection>
            <InputBox
              label='Client Address'
              placeholder='eg, 692 SW. 53rd St. Irwin, PA 15642'
              value={orgAddress.value}
              onChange={event => {
                setOrgAddress({ value: event.target.value, error: '' });
              }}
              errorMessage={orgAddress.error}
            />

            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <InputBox
                label='Client Logo (optional)'
                type='file'
                placeholder='Choose Logo'
                // value={orgAddress.value}
                onChange={event => {
                  setOrgLogo({ value: event.target.files[0], error: '' });
                }}
                errorMessage={orgLogo.error}
                style={{ width: '25rem' }}
              />
              {editOrgData && editOrgData.photo && (
                <a
                  href={process.env.REACT_APP_BASE_SOCKET_URL + '/' + editOrgData.photo}
                  target='__blank'
                  style={{
                    alignSelf: 'flex-end',
                    textDecoration: 'none',
                    color: 'var(--primary-color)',
                    fontWeight: '600',
                    fontSize: '1.1rem',
                  }}
                >
                  View Current Logo
                </a>
              )}
            </div>

            {(Object.keys(editOrgData).length === 0 || (editOrgData.customClient && editOrgData.customClientDetails)) && (
              <InputBox
                label='Allocate Space (in GB)'
                placeholder='eg, 100'
                value={customClientData.space.value}
                onChange={event => {
                  setCustomClientData({
                    ...customClientData,
                    space: { value: event.target.value, error: '' },
                  });
                }}
                errorMessage={customClientData.space.error}
              />
            )}
          </InputsSection>

          {(Object.keys(editOrgData).length === 0 || (editOrgData.customClient && editOrgData.customClientDetails)) && (
            <InputsSection>
              <InputBox
                label='Total Admin Users'
                placeholder='eg, 10'
                value={customClientData.adminUsers.value}
                onChange={event => {
                  setCustomClientData({
                    ...customClientData,
                    adminUsers: { value: event.target.value, error: '' },
                  });
                }}
                errorMessage={customClientData.adminUsers.error}
              />
              <InputBox
                label='Total File Users'
                placeholder='eg, 500'
                value={customClientData.downloadUsers.value}
                onChange={event => {
                  setCustomClientData({
                    ...customClientData,
                    downloadUsers: { value: event.target.value, error: '' },
                  });
                }}
                errorMessage={customClientData.downloadUsers.error}
              />
            </InputsSection>
          )}
          <InputsSectionColumn>
            <p className={TextBox.form_input__label}>Allowed Modules</p>
            <div className='flex' style={{ gap: '2rem' }}>
              <div className='flex'>
                <label htmlFor='client-chat'>Chat module</label>
                <label className='switch'>
                  <input
                    id='client-chat'
                    checked={orgModules.chat}
                    onChange={e => {
                      setOrgModules({ ...orgModules, chat: !orgModules.chat });
                    }}
                    type='checkbox'
                    className='checkbox'
                    name='active'
                  />
                  <span className='slider round' />
                </label>
              </div>
              <div className='flex'>
                <label htmlFor='admin-only-chat'>Admins only Chat</label>
                <label className='switch'>
                  <input
                    id='admin-only-chat'
                    checked={orgModules.adminOnlyChat}
                    onChange={() => setOrgModules({ ...orgModules, adminOnlyChat: !orgModules.adminOnlyChat })}
                    type='checkbox'
                    className='checkbox'
                    name='active'
                  />
                  <span className='slider round' />
                </label>
              </div>
              <div className='flex'>
                <label htmlFor='client-video-call'>Video Call module</label>
                <label className='switch'>
                  <input
                    id='client-video-call'
                    checked={orgModules.videoCall}
                    onChange={() => setOrgModules({ ...orgModules, videoCall: !orgModules.videoCall })}
                    type='checkbox'
                    className='checkbox'
                    name='active'
                  />
                  <span className='slider round' />
                </label>
              </div>
              <div className='flex'>
                <label htmlFor='client-file-sharing'>File Exchange</label>
                <label className='switch'>
                  <input
                    id='client-file-sharing'
                    checked={orgModules.fileSharing}
                    onChange={() => setOrgModules({ ...orgModules, fileSharing: !orgModules.fileSharing })}
                    type='checkbox'
                    className='checkbox'
                    name='active'
                  />
                  <span className='slider round' />
                </label>
              </div>
              <div className='flex'>
                <label htmlFor='client-file-sharing'>Website Forms</label>
                <label className='switch'>
                  <input
                    id='client-file-sharing'
                    checked={orgModules.websiteForms}
                    onChange={() => setOrgModules({ ...orgModules, websiteForms: !orgModules.websiteForms })}
                    type='checkbox'
                    className='checkbox'
                    name='active'
                  />
                  <span className='slider round' />
                </label>
              </div>
            </div>
          </InputsSectionColumn>

          <ModalButtons
            submitButtonLabel={editOrgData && editOrgData._id ? 'Update Client' : 'Add Client'}
            onSubmit={handleAddOrg}
            cancelButtonLabel='Cancel'
            onCancel={handleAddModalClose}
          />
        </ModalForm>
      )}
    </Modal>
  );
};

export default AddOrgModal;
